import ApiService from "@/api.service";
import API from "@/API";

export const GET_LIST_USER = "listUser";
export const GET_DETAIL_USER = "detailUser";
export const SAVE_USER = "saveUser";
export const UPDATE_DATA_USER = "updateDataUser";
export const DELETE_USER = "deleteUser";
export const UPLOAD_AVATAR_USER = "uploadUser";
export const GET_DATA_SEARCH_USER = "getDataSearchUser";
export const SET_DATA_SEARCH_USER = "setDataSearchUser";

export const SET_LIST_USER = "setListUser";
export const SET_DETAIL_USER = "setDetailUser";


const state = {
    users: [],
    user: {},
    dataSearchUser: [],
};

const getters = {
    users(state) {
        return state.users;
    },
    user(state) {
        return state.user;
    },
    dataSearchUser(state) {
        return state.dataSearchUser;
    },
};

const actions = {
    [GET_LIST_USER](context) {
        return new Promise(resolve => {
            ApiService.query(API.GET_LIST_USER).then(({ data }) => {
                if (data.status) {
                    context.commit(SET_LIST_USER, data);
                }
                resolve(data);
            });
        });
    },
    [GET_DETAIL_USER](context, id) {
        return new Promise(resolve => {
            ApiService.query(`${API.GET_DETAIL_USER}/${id}`).then(({data}) => {
                if (data.status) {
                    context.commit(SET_DETAIL_USER, data);
                }
                resolve(data);
            });
        });
    },
    [SAVE_USER](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`${API.SAVE_USER}`, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    console.log(err)
                    reject(err);
                });
        });
    },
    [UPDATE_DATA_USER](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.update(`${API.UPDATE_USER}`, payload.id, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    console.log(err)
                    reject(err);
                });
        });
    },
    [DELETE_USER](context, id) {
        return new Promise((resolve, reject) => {
            ApiService.delete(`${API.DELETE_USER}`, id)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    console.log(err)
                    reject(err);
                });
        });
    },

    [GET_DATA_SEARCH_USER](context, payload) {
        return new Promise(resolve => {
            ApiService.query(API.GET_LIST_SEARCH_USER, payload).then(({ data }) => {
                if (data.status) {
                    context.commit(SET_DATA_SEARCH_USER, data.data.data);
                }
                resolve(data);
            });
        });
    },
};

const mutations = {
    [SET_LIST_USER](state, data) {
        state.users = data.data;
    },
    [SET_DETAIL_USER](state, data) {
        state.user = data.data;
    },
    [SET_DATA_SEARCH_USER](state, data) {
        state.dataSearchUser = data
    }
};

export default {
    state,
    actions,
    mutations,
    getters
};